import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const TreeViewWrapper = styled.div`
  min-width: ${rem(396)};
  margin: ${rem(24)} ${rem(24)} 0 ${rem(24)};
  height: 80%;
  min-height: ${rem(400)};

  @media ${({ theme }) => theme.breakpoints.lg} {
    width: 100%;
  }
`;

export const DrawerHeader = styled.div`
    padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(24)};
    display: flex;
    align-items: center;
    font-family: 'Pizza Hut';
    font-weight: 400;
    height: 40px;
    font-size: ${rem(26)};
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.gray900};
    background-color: ${({ theme }) => theme.colors.gray100};
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  border-left: 1px solid ${({ theme }) => theme.colors.gray400};
  border-right: 1px solid ${({ theme }) => theme.colors.gray400};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  button {
    margin: ${rem(16)};
  }
`;

export const ExportButtonWrapper = styled.div`
  display: flex;
  padding: ${rem(16)} ${rem(16)} ${rem(16)} ${rem(24)};
  justify-content: flex-end;
`;